import { render, staticRenderFns } from "./RasConfigurazionePostiLettoPianiViewPage.vue?vue&type=template&id=3b82f85a"
import script from "./RasConfigurazionePostiLettoPianiViewPage.vue?vue&type=script&lang=js"
export * from "./RasConfigurazionePostiLettoPianiViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports